export default __webpack_public_path__ + "static/media/icon-published.1c3c686a.svg";